import { render } from "./ClientManagersManagement.vue?vue&type=template&id=4261696c&scoped=true"
import script from "./ClientManagersManagement.vue?vue&type=script&lang=js"
export * from "./ClientManagersManagement.vue?vue&type=script&lang=js"

import "./ClientManagersManagement.vue?vue&type=style&index=0&id=4261696c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4261696c"]])

export default __exports__